import { Img } from "container/Manual/components/content/Image";
import { Paragraph } from "container/Manual/components/content/Paragraph";
import { Li } from "container/Manual/components/list/Li";
import { Ul } from "container/Manual/components/list/Ul";
import { CardSection } from "container/Manual/components/section/CardSection";
import { ListSection } from "container/Manual/components/section/ListSection";

export const STR = () => {
  return (
    <CardSection id="STR" title="STR">
      <Paragraph>인수의 데이터를 텍스트 문자열로 변환합니다.</Paragraph>

      <ListSection title="Syntax">
        <Paragraph accent>STR(VALUE)</Paragraph>
        <Ul>
          <Li>
            <b>VALUE</b>는 텍스트 문자열로 변환하려는 값입니다.
          </Li>
        </Ul>
      </ListSection>

      <ListSection title="Example">
        <Paragraph accent>STR(`quantity`)</Paragraph>
        <Img src="computeStr" />
      </ListSection>

      <ListSection title="Notes on use">
        <Paragraph>
          제공하는 <b>VALUE</b>는 숫자 값이거나, 숫자 값이 포함된 열이거나, 숫자
          값을 반환하는 함수여야 합니다.
        </Paragraph>
        <Paragraph>
          이 기능은 숫자를 텍스트로 변환하거나, 숫자와 텍스트가 섞인 열을 텍스트
          형식으로 통일해 다른 텍스트 함수들이 정상적으로 작동하도록 도와줍니다.
        </Paragraph>
      </ListSection>
    </CardSection>
  );
};
